import React from 'react';
import { Drawer } from 'antd';
import {backArrow, popup_close} from '../../../assets/images'

const CustomAppointmentDrawer = ({
  title,
  handleBack,
  handleCancel,
  body,
  showBackButton = true
}) => {

  const getHeight = () => {
    return title == 'Appointment booked' ? '100%' : '91.4%'
  }

  const getTitle = () => {
    return (
      <div className='flex justify-between py-3'>
        <div className='flex items-center justify-center'>
          {showBackButton && <img
            src={backArrow}
            alt='back-arrow'
            onClick={handleBack}
            style={{ cursor: 'pointer', height: '0.75rem' }}
          />}
          <span className='mx-2 text-lg' style={{fontWeight: '600'}}>{title}</span>
        </div>
        <img
          src={popup_close}
          alt='close-icon'
          onClick={handleCancel}
          style={{ cursor: 'pointer', height: '32px' }}
        />
      </div>
    )
  }
  
  return (
    <Drawer
    closable={false}
    title={ title == 'Appointment booked' ? null : getTitle() }
    footer={null}
    drawerStyle={{overflowX: 'hidden', background: '#F5F7F9', height: '100%'}}
    bodyStyle={{overflowX: 'hidden', padding : '0px', height: getHeight()}}
    headerStyle={{
          backgroundColor: 'white',
          padding: '0 1.5rem',
        }}
    visible={true}
    width='40%'
    >
      {body}
    </Drawer>
  );
};

export default CustomAppointmentDrawer;